export enum ReviewConfigurationTypes {
  BAD = 'Bad',
  GOOD = 'Good',
}

export const reviewConfigurationLabel = {
  [ReviewConfigurationTypes.BAD]: 'Negative',
  [ReviewConfigurationTypes.GOOD]: 'Positive',
};

export interface IReviewConfiguration {
  type: ReviewConfigurationTypes;
  body: string;
  isAutoResponse: boolean;
}

export interface IUpdateReviewConfigurationRequest {
  configurations: IReviewConfiguration[];
}
